import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FCMTokenManager } from '@/firebase';
import useToast from '@/hooks/useToast';
import { getTokens } from '@/utils/auth-fns';

import Layout from '../features/layout/Layout';

const PrivateRoute = () => {
  const location = useLocation();
  const toast = useToast();
  const tokens = getTokens();

  useEffect(() => {
    // 토근이 없는 경우, 에러 메시지 노출
    // 단, spation.com 으로 진입시에는 에러 메시지를 노출하지 않습니다.!
    if (location.pathname !== '/' && !tokens) {
      toast.error('로그인이 필요합니다');
    }
  }, [location]);

  // 토큰이 없는 경우, 로그인 화면으로 이동
  if (!tokens) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // spation.com으로 화면 진입시 토큰이 있는 경우, 업무관리 화면으로 이동
  if (location.pathname === '/' && tokens) {
    return <Navigate to="/task" state={{ from: location }} />;
  }

  return (
    <Layout>
      <FCMTokenManager />
      <Outlet />
    </Layout>
  );
};

export default PrivateRoute;
